import { createRoot } from "react-dom/client";
import { MobileRouter } from "./react/legacy/MobileRouter";

// initialize react
const root = createRoot(getElementByIdOrThrow("react-app"));
root.render(<MobileRouter />);

function getElementByIdOrThrow(id: string) {
  const result = document.getElementById(id);
  if (!result) {
    throw new Error(`Element #${id} not found`);
  }
  return result;
}
